import request from './request';

export function getEventConfig() {
  return request({
    method: 'post',
    url: '/api/v1/w/prayingCash/config',
    data: {
      config_code: sessionStorage.getItem('cfc')
    }
  });
}

export function getRecaptchaScript() {
  return request({
    method: 'get',
    url: '/prayingCash/js/recaptcha.js',
    responseType: 'HTML'
  });
}

export function checkReserve(phoneNumber) {
  return request({
    method: 'post',
    url: '/api/v1/w/prayingCash/reserve',
    data: {
      config_code: sessionStorage.getItem('cfc'),
      mobile_phone_number: phoneNumber
    }
  });
}
